import * as XLSX from "xlsx";
import { traduzCategoria } from "./telemetryParser";
import { PARAMETER_MAP } from "./PARAMETER_MAP";
export async function exportTelemetryToCSV({
    data,
    filters,
    total,
    signal,
    setProgress,
    setProcessing,
    onError
}) {
    try {
        setProcessing?.(true);
        setProgress?.(0);

        const now = new Date();

        const normalizedData = (data || []).flatMap((trem) => {
            const mensagens = trem?.data || [];

            return mensagens.map((msg) => {

                const timestamp = msg.messageTimestamp ?? msg.message_timestamp ?? null;

                const normalizedTimestamp =
                    timestamp && timestamp < 1e12
                        ? timestamp * 1000
                        : timestamp;

                return {
                    id: msg.id ?? `${msg.messageId}-${msg.parameterId}`,
                    tremId: msg.tremId ?? trem.idTrem ?? "-",
                    carro: msg.carro ?? "-",
                    category: msg.category ?? null,
                    parameterId: msg.parameterId ?? "-",

                    parameterName:
                        PARAMETER_MAP?.[String(msg.parameterId)]?.name ?? null,

                    parameterValue: msg.parameterValue ?? "-",
                    messageId: msg.messageId ?? "-",
                    batchId: msg.batchId ?? "-",
                    publisherId: msg.publisherId ?? "-",
                    messageTimestamp: normalizedTimestamp,
                    createdAt: msg.createdAt ?? null
                };
            });
        });

        const header = [
            "ID",
            "Trem",
            "Carro",
            "Categoria",
            "Parâmetro",
            "Valor",
            "Message ID",
            "Batch ID",
            "Publisher",
            "Horário Core",
            "Criado em"
        ];

        const rows = [];
        const totalRows = normalizedData.length;

        for (let i = 0; i < totalRows; i++) {

            if (signal?.aborted) {
                return;
            }

            const row = normalizedData[i];

            rows.push([
                row.id ?? "-",
                row.tremId ?? "-",
                row.carro ?? "-",
                traduzCategoria(row.category),
                row.parameterName
                    ? `${row.parameterId} - ${row.parameterName}`
                    : row.parameterId ?? "-",
                row.parameterValue ?? "-",
                `="${row.messageId ?? "-"}"`,
                `="${row.batchId ?? "-"}"`,
                `="${row.publisherId ?? "-"}"`,

                row.messageTimestamp
                    ? new Date(Number(row.messageTimestamp)).toLocaleString("pt-BR")
                    : "-",

                row.createdAt
                    ? new Date(row.createdAt + "Z").toLocaleString("pt-BR")
                    : "-"
            ]);

            if (i % 100 === 0) {
                const percent = Math.round((i / totalRows) * 100);
                setProgress?.(percent);

                await new Promise(resolve => setTimeout(resolve, 0));
            }
        }

        const aoa = [header, ...rows];

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        const csv = XLSX.utils.sheet_to_csv(ws, {
            FS: ";",
            RS: "\n"
        });

        if (signal?.aborted) {
            return;
        }

        const blob = new Blob(["\uFEFF" + csv], {
            type: "text/csv;charset=utf-8;"
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `telemetria_${now.toISOString().slice(0, 10)}.csv`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        setProgress?.(100);

    } catch (error) {
        if (error.name !== "AbortError") {
            onError?.("Erro ao exportar CSV. Tente novamente.");
        }
    } finally {
        setProcessing?.(false);
    }
}